import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly5C2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/5C/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/5C/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/5C/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/5C/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/class-assembly/5C/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/class-assembly/5C/6.webp`;




  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
    { src: p5, source: p5, rows: 1, cols: 1 },
    { src: p6, source: p6, rows: 1, cols: 1 },
  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
                    Yoga for Health and Harmony
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class: 5C   Date:29, 30 JUNE, 01 JULY 2026 
                </Typography>

        <Typography variant={'subtitle1'} align={'justify'}>
       “Yoga is the journey of the self, through the self, to the self—nurturing a healthy body, a peaceful mind and a
        balanced life.”
        <br></br>
                    The enthusiastic students of Class 5C presented an inspiring assembly on the theme ‘Yoga for Health and
Harmony’ from Monday to Wednesday, 29 June to 1 July 2026. The assembly began with a meaningful Thought
for the Day, followed by a brief introduction highlighting the importance of yoga in leading a healthy and
balanced life.
            <br></br>
                   The students shared interesting facts about yoga and delivered an informative speech on its physical and
mental benefits. The highlight of the assembly was the graceful demonstration of various yogasanas by the
entire class, showcasing excellent coordination, balance and discipline. An engaging yoga quiz added an
interactive element and encouraged enthusiastic participation from the audience.
                    <br></br>
            The assembly concluded with a heartfelt Yoga Pledge, where students pledged to practise yoga regularly and
lead a healthy lifestyle. The presentation ended on an inspiring note, encouraging everyone to embrace yoga as
a way of life.
        <br></br>
        </Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
                “Yoga is the art of awakening the body, calming the mind and nourishing the soul.”
                 <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 5C 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly5C2026;
